export default __webpack_public_path__ + "static/media/sprint-facilitation.754bd920.svg";